import { render, staticRenderFns } from "./TemplateTextEditor.vue?vue&type=template&id=4f701dda&scoped=true&"
import script from "./TemplateTextEditor.vue?vue&type=script&lang=ts&"
export * from "./TemplateTextEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateTextEditor.vue?vue&type=style&index=0&id=4f701dda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f701dda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
